import React from 'react';

export const VaultCardListClean = ({ vault }) => {
  return (
    <div className="flex items-center justify-between bg-white/5 border border-white/10 rounded-xl px-4 py-3 backdrop-blur-md">
      <div className="flex items-center gap-4">
        <img
          src={`https://flagcdn.com/w40/${vault.flagCode?.toLowerCase()}.png`}
          alt="flag"
          className="w-8 h-8 rounded-full object-cover border border-white/20"
        />
        <div>
          <div className="text-white font-semibold">{vault.vaultAlias}</div>
          <div className="text-sm text-white/60">{vault.owner}</div>
        </div>
      </div>

      <div className="text-right">
        <div className="text-green-400 font-medium text-lg">
          {vault.currencyCode} {vault.balance.toLocaleString()}
        </div>
        <div className="text-xs text-white/40 uppercase">{vault.country}</div>
      </div>
    </div>
  );
};
